import React from "react";

import ProductGroupItem from "./ProductGroupItem";

const ProductGroupList = ({
    groups = [],
    selectedGroupId,
    onGroupSelect
}) => {

    if (!groups.length) {
        return (
            <div className="product-group-list">
                <div className="product-group-empty">
                    گروهی وجود ندارد
                </div>
            </div>
        );
    }

    return (
        <div className="product-group-list">

            {groups.map((group, index) => (
                <ProductGroupItem
                    key={
                        group.id ??
                        group.ID ??
                        group.groupId ??
                        index
                    }
                    group={group}
                    selected={
                        String(
                            group.id ??
                            group.ID ??
                            group.groupId
                        ) === String(selectedGroupId)
                    }
                    onClick={onGroupSelect}
                />
            ))}

        </div>
    );
};

export default ProductGroupList;

